export default "__VITE_ASSET__BWzWItQQ__"